import { ModalBaseComponent } from '../../components/modal-base/modal-base.component';
import { ModalButton } from './modal-button';

export interface IModalComponent {
    baseComponent: ModalBaseComponent;
    title?: string;
    buttons: ModalButton[];
    data: any;
}

export enum ModalWidth {
    sm = 400,
    md = 500,
    lg = 750,
    xl = 900,
}



// WEBPACK FOOTER //
// /app/src/app/types/modal/modal-base.ts